<template>
    <div class="row">
        <div class="col-12" v-if="asientos === null">
            <PasoUnoComponent
                v-if="! bloqueando"
                :sesion="pack.sesiones[index]"
                :pack="pack"
                :session_id="session_id"
                :precios_seleccionados="precios_seleccionados"
                :n_asientos="n_asientos"
                @continuar="asientosBloqueados"
            />
            <section v-else class="padding-vertical-content" id="paso-1">
                <div class="container">
                    <div class="row">
                        <b-col cols="12" class="text-center">
                            <h2 class="h1">Bloqueando butacas...</h2>
                        </b-col>
                    </div>
                </div>
            </section>
        </div>
        <b-col cols="12" v-else>
            <PasoTres
                v-if="asientos.length > 0"
                :pack="pack"
                :asientos="asientos"
                :session_id="session_id"
                :continuarConCompra="continuarConCompra"
                @continuar="pasoTresTerminado"
            />

            <PasoCuatro
                v-if="procesarPago"
                :asientos="asientos"
                :datos_comprador="datos_comprador"
                :formulario="formulario_compra"
                :jet_id="jet_id"
                :session_id="session_id"
            />
        </b-col>
    </div>
</template>

<script>
import PasoUnoComponent from "@/components/frontend/packs/venta/con_recinto/distinta_butaca/pasos/PasoUnoComponent.vue";
import PasoTres from "@/components/frontend/packs/venta/con_recinto/misma_butaca/pasos/PasoTres.vue";
import PasoCuatro from "@/components/frontend/packs/venta/con_recinto/misma_butaca/pasos/PasoCuatro.vue";
export default {
    props:{
        pack: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            index : 0,
            bloqueando: false,
            session_id: null,
            precios_seleccionados: [],
            n_asientos: null,
            asientos: null,
            formulario_compra: null,
            datos_comprador: null,
            continuarConCompra: false,
            jet_id: null,
            procesarPago: false
        }
    },
    methods: {
        asientosBloqueados(asientos, session_id) {
            this.bloqueando = true;
            this.session_id = session_id;
            if(this.index < this.pack.sesiones.length - 1) {
                this.index = this.index + 1;
                this.n_asientos = asientos.length;

                asientos.forEach(asiento => {
                    this.precios_seleccionados.push(asiento.precio.id);
                });

                setTimeout(() => {
                    this.bloqueando = false;
                }, 1000);
            } else {
                this.asientos = asientos;
            }
        },
        pasoTresTerminado(datos, formulario, jet_id) {
            this.formulario_compra = formulario;
            this.jet_id = jet_id;
            this.datos_comprador = datos;
            this.continuarConCompra = true;
            this.procesarPago = true;
            this.$nextTick(() => {
                this.$scrollTo('#resumen', 300);
            });
        }
    },
    components: {
        PasoCuatro, PasoTres,
        PasoUnoComponent
    }
}
</script>